export const tourStrugglingTimeoutDuration = 30000; // 30 seconds
